export default __webpack_public_path__ + "static/media/VKOW_11_mos_JTAN.4426b64f.wav";